

















































import { LocaleMixin } from '@/locales/locale-mixin';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { emailValidationRules } from '@/crm-types/field-utils';
import BaseDateInput from '@/components/base/BaseDateInput.vue';
import { BasicValidationMixin } from '@/validation/basic-validation-mixin';
import { EventTypes } from '@/constants/event-type-constants';

@Component({
    components: { BaseDateInput }
})
export default class InlineEditable extends Mixins(LocaleMixin, BasicValidationMixin) {
    $refs!: {
        input: Vue & {
            $el?: HTMLElement;
        };
    }

    @Prop({ type: String }) readonly input!: string;
    @Prop() readonly label!: string;
    @Prop({ type: String }) readonly colSize!: string;
    @Prop({ type: Boolean, default: false }) readonly isEmailInput!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isPhoneInput!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isRequired!: boolean;
    @Prop({ type: Boolean, default: false }) readonly overflowEllipsis!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

    private editable = false;
    private localValue = '';

    created() {
        this.localValue = this.input || '';
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    beforeDestroy() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    @Watch('input')
    onInputChange(newValue: string) {
        this.localValue = newValue || '';
    }

    get textClass() {
        return this.overflowEllipsis ? 'overflow-ellipsis' : '';
    }

    private handleKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' && this.editable) {
            event.preventDefault();
            this.handleClose();
        }
    }

    private handleClickOutside(event: MouseEvent) {
        if (this.editable) {
            const element = this.$el as HTMLElement;
            if (!element.contains(event.target as Node)) {
                this.handleClose();
            }
        }
    }

    private handleClose() {
        this.editable = false;
        // Only emit if the value actually changed
        if (this.localValue !== this.input) {
            this.$emit(EventTypes.UPDATED, this.localValue);
        }
    }

    private toggleEdit() {
        if (!this.editable && !this.disabled) {
            this.editable = true;
            this.$nextTick(() => {
                if (this.$refs.input) {
                    if (this.$refs.input.$el) {
                        const input = this.$refs.input.$el.querySelector('input');
                        if (input) input.focus();
                    }
                }
            });
        }
    }

    get nonRequiredEmail() {
        return emailValidationRules();
    }

    get inputSynced() {
        return this.localValue;
    }

    set inputSynced(value: string) {
        this.localValue = value;
    }

    get generateSpanText(): string {
        const displayValue = this.editable ? this.localValue : this.input;
        if (displayValue === '') {
            return this.label;
        } else if (this.isPhoneInput) {
            return this.formatPhone(displayValue);
        } else {
            return displayValue;
        }
    }
}
